/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var rangeInputDefaultProps = {
  clearable: false,
  readonly: false,
  separator: "-",
  showClearIconOnEmpty: false,
  size: "medium",
  status: "default",
  defaultValue: []
};
var rangeInputPopupDefaultProps = {
  autoWidth: false,
  readonly: false,
  status: "default"
};

export { rangeInputDefaultProps, rangeInputPopupDefaultProps };
//# sourceMappingURL=defaultProps.js.map
